import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
export var normalizeNO = function normalizeNO(entityArray) {
  var schema = {};
  var normalized = entityArray.reduce(function (normalizedObject, item) {
    var newNormalizedObject = normalizedObject;
    newNormalizedObject[item.id] = item;
    return newNormalizedObject;
  }, schema);
  return normalized;
};